import './App.css';
import './fountain.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Web3ReactProvider } from '@web3-react/core';
import Web3 from 'web3';
import Layout from "./pages/Layout";
import Home from "./pages/Home";
import Faucet from "./pages/Faucet";
import Fountain from "./pages/Fountain";
import Reservoir from "./pages/Reservoir";


function getLibrary(provider, connector) {
  return new Web3(provider);
}

function App() {
  return (
  	<Web3ReactProvider getLibrary={getLibrary}>
     <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout webtype={Web3}/>}>
          <Route index element={<Home webtype={Web3}/>} />
          <Route path="Home" element={<Home webtype={Web3}/>} />
          <Route path="Faucet" element={<Faucet webtype={Web3}/>} />
          <Route path="Fountain" element={<Fountain webtype={Web3}/>} />
          <Route path="Reservoir" element={<Reservoir webtype={Web3}/>} />
        </Route>
      </Routes>
     </BrowserRouter>
    </Web3ReactProvider>
  );
}

export default App;